var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-dashboard"},[_c('layout-basic',{attrs:{"title":"后台系统","user":_vm.dashboardInfo,"menu":_vm.menu,"siderWidth":"200px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }